import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Button, Modal, Form, message, Table } from "antd";
import AppConfigs from "../Config/AppConfig";
import { add } from "../api/Apis";

class RequestCarriersList extends Component {
  constructor() {
    super();
    this.state = {
      dataLoadingStatus: false,
      driversList: [],
      editMode: false,
      startOpen: false,
      endOpen: false,
      startValue: "",
      endValue: "",
      trucks: [],
    };
  }

  componentDidMount = () => {};

  // requestLead = (e) => {
  //   e.preventDefault();
  //   this.props.form.validateFieldsAndScroll(async (err, values) => {
  //     if (!err) {
  //       this.setState({
  //         loading: true,
  //       });
  //       let pickupDate = moment(values["pickupDate"]).format("MM/DD/YYYY");
  //       let deliveryDate = moment(values["deliveryDate"]).format("MM/DD/YYYY");
  //       // let pickupStartTime = moment(values["pickupStartTime"]).format(
  //       //   "hh:mm A"
  //       // );
  //       // let pickupEndTime = moment(values["pickupEndTime"]).format("hh:mm A");
  //       let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
  //       let data = {};
  //       let driverDetails = this.state.driversList.filter(
  //         (driver) => driver.id === values["driver"]
  //       );
  //       let truckDetails = this.state.trucks.filter(
  //         (truck) => truck.truckNumber === values["truckNumber"]
  //       );

  //       if (
  //         this.props.leadData["orderStatus"] === "AC" ||
  //         this.props.leadData["orderStatus"] === "I"
  //       ) {
  //         data = {
  //           entityData: {
  //             pickupDate: pickupDate,
  //             deliveryDateAndTime: deliveryDate,
  //             pickupStartTime: null,
  //             pickupEndTime: null,
  //             driverDetails: {
  //               name:
  //                 driverDetails[0]["firstName"] +
  //                 " " +
  //                 driverDetails[0]["lastName"],
  //               phone: driverDetails[0]["phone"],
  //               // "truckNumber": values["truckNumber"],
  //               id: driverDetails[0]["id"],
  //             },
  //             truckDetails: {
  //               truckNumber: truckDetails[0]["truckNumber"],
  //               typeOfTruck: truckDetails[0]["typeOfTruck"],
  //               id: truckDetails[0]["id"],
  //             },

  //             orderStatus: AppConfigs["IN_PROGRESS"],
  //           },
  //         };
  //         if (!this.state.editMode) {
  //           data["entityData"]["driverDetails"] = {
  //             name:
  //               driverDetails[0]["firstName"] +
  //               " " +
  //               driverDetails[0]["lastName"],
  //             phone: driverDetails[0]["phone"],
  //             // "truckNumber": values["truckNumber"],
  //             id: driverDetails[0]["id"],
  //           };
  //           data["entityData"]["truckDetails"] = {
  //             truckNumber: truckDetails[0]["truckNumber"],
  //             typeOfTruck: truckDetails[0]["typeOfTruck"],
  //             id: truckDetails[0]["id"],
  //           };
  //           // data["entityData"]["driverDetails"]["truckNumber"] = values["truckNumber"]
  //         }
  //         update(
  //           AppConfigs["entityNames"]["leads"],
  //           this.props.leadData["id"],
  //           data
  //         ).then((result) => {
  //           if (result.success) {
  //             this.props.hideModal();
  //             message.success("Pickup date and time updated successfully!");
  //             if (this.props.callFrom === "orders") {
  //               this.props.getOrders();
  //             } else {
  //               this.props.getLoadDetails();
  //             }
  //           } else {
  //             this.setState({
  //               loading: false,
  //             });
  //             console.log(result.errors);
  //           }
  //         });
  //       } else {
  //         data = {
  //           entityData: {
  //             leadId: this.props.leadData["id"],
  //             carrierId: orgDetails["id"],
  //             carrierName: orgDetails["companyName"],
  //             rateValue: this.props.leadData["rateValue"],
  //             callForRate: this.props.leadData["callForRate"],
  //             rateAmt: this.props.leadData["rateAmt"],
  //             rateOption: this.props.leadData["rateOption"],
  //             pickupDate: pickupDate,
  //             deliveryDateAndTime: deliveryDate,
  //             pickupStartTime: null,
  //             pickupEndTime: null,
  //             driverDetails: {
  //               name:
  //                 driverDetails[0]["firstName"] +
  //                 " " +
  //                 driverDetails[0]["lastName"],
  //               phone: driverDetails[0]["phone"],
  //               // "truckNumber": values["truckNumber"],
  //               id: driverDetails[0]["id"],
  //             },
  //             truckDetails: {
  //               truckNumber: truckDetails[0]["truckNumber"],
  //               typeOfTruck: truckDetails[0]["typeOfTruck"],
  //               id: truckDetails[0]["id"],
  //             },
  //             carrierEmail: orgDetails["email"],
  //             // "truckNumber": values["truckNumber"],
  //             orderStatus: AppConfigs["IN_PROGRESS"],
  //           },
  //         };
  //         add(AppConfigs["assignLead"], data).then((result) => {
  //           if (result.success) {
  //             this.props.hideModal();
  //             message.success("Load assigned successfully!");
  //             if (this.props.callFrom === "orders") {
  //               this.props.getOrders();
  //             } else {
  //               this.props.getLoadDetails();
  //             }
  //           } else {
  //             this.setState({
  //               loading: false,
  //             });
  //             // message.error(result.errors);
  //             console.log(result.errors);
  //             this.props.history.push("/carrier_app/allOrders");
  //           }
  //         });
  //       }
  //     }
  //   });
  // };

  LoadAssign = (id) => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        requestId: id,
        orderStatus: AppConfigs["IN_PROGRESS"],
      },
    };
    add(AppConfigs["approveLoadAssignment"], data).then((result) => {
      if (result.success) {
        message.success("Load assigned successfully!");
        if (this.props.callFrom === "orders") {
          if (this.props.defaultStatus === "PC") {
            this.props.getOrders("PC");
          } else {
            this.props.getOrders();
          }
        } else {
          window.location = "/app/loads/loaddetails/" + id;
          window.location.reload();
        }
        this.setState({
          dataLoadingStatus: false,
        });
        this.props.closeCarriersList();
      } else {
        this.setState({
          loading: false,
          dataLoadingStatus: false,
        });
        this.props.closeCarriersList();
      }
    });
  };

  render() {
    // const { getFieldDecorator } = this.props.form;
    const carrierRequestsColumns = [
      {
        title: <div style={{ color: "grey" }}>Carrier</div>,
        dataIndex: "assignCarrier",
        key: "assignCarrier",
        render: (assignCarrier, record) => (
          <span>
            <div style={{ color: "black" }}>
              {record["carrierDetails"]["carrierName"]}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Pick-Up Date</div>,
        dataIndex: "pickupDate",
        key: "pickupDate",
        render: (pickupDate, record) => (
          <span>
            <div style={{ color: "black" }}>{pickupDate}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Estimate Delivery Date</div>,
        dataIndex: "estimatedDeliveryDate",
        key: "estimatedDeliveryDate",
        render: (estimatedDeliveryDate) => (
          <span>
            <div style={{ color: "black" }}>{estimatedDeliveryDate}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}></div>,
        dataIndex: "id",
        key: "id",
        render: (id, record) => (
          <span>
            <Button
              type="success"
              onClick={() => this.LoadAssign(id)}
              style={{
                margin: "15px",
                background: "green",
                borderColor: "green",
                color: "rgb(255, 255, 255)",
              }}
              icon="check"
            >
              Approve
            </Button>
          </span>
        ),
      },
    ];
    console.log(this.props.deliveryReqDate, this.props);
    return (
      <main>
        <Form>
          <Modal
            visible={this.props.carrierRequestsModalStatus}
            closable={true}
            footer={[
              <Button
                key="cancel"
                className="cancel"
                onClick={() => {
                  this.props.closeCarriersList();
                }}
              >
                Cancel
              </Button>,
            ]}
            width="70%"
          >
            <div>
              <Row>
                <div>
                  <h1>
                    {"Requested Delivery Date : " + this.props.deliveryReqDate}
                  </h1>
                </div>
                <div className="loadstable">
                  <Table
                    columns={carrierRequestsColumns}
                    dataSource={this.props.carrierRequests}
                    loading={
                      this.props.dataLoadingStatus ||
                      this.state.dataLoadingStatus
                    }
                    rowKey={(record) => record.id}
                    onRow={(r) => ({
                      style: { cursor: "pointer" },
                    })}
                  />
                </div>
              </Row>
            </div>
          </Modal>
        </Form>
      </main>
    );
  }
}

export default Form.create({ name: "RequestCarriersList" })(
  RequestCarriersList
);
